import * as types from '../actionTypes/OrderActionTypes';

export default function OrderTotalsReducer(state = {}, action) {
    // NOSONAR
    switch (
        action.type // NOSONAR
    ) {
        case types.GET_ORDER_TOTALS:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}
